import React, { useState, useEffect } from 'react';
//Components
import { Conditional } from 'common/components/layout';
import StudyUsersTeamTable from 'pages/studyOverview/containers/StudyUsers/StudyUsersTeamTable';
import SignatureStatusNew from './SignatureStatusNew';
import { Spinner } from 'components/common/LoadingStatus/LoadingStatus';
import { faList, faCloudDownload } from '@fortawesome/free-solid-svg-icons';
import DelegationPopoverTaskNewDOA from '../components/DelegationPopoverTask/DelegationPopoverTaskNewDOA';

//utils
import { sortBy, toLower, get, map, isEmpty, orderBy } from 'lodash';
import { FilterState } from 'common/components/TableToolbar/FilterPopover';
import { connect } from 'react-redux';
import moment from 'moment';

//selectors
import {
    getDelegationTaskOptions,
} from 'pages/delegationOfAuthority/selectors';

//styles
import styles from './DelegationOfAuthorityV2.scss';

const delegationsListV2 = async (doaStudyDelegation, doaStudyTask) => {
    const doaStudyDelegations = doaStudyDelegation;
    const doaStudyTasks = doaStudyTask;

    if (!doaStudyDelegations || !doaStudyTasks || doaStudyDelegations.length === 0 || doaStudyTasks.length === 0) {
        return [];
    }

    const tasksMap = doaStudyTasks.reduce((acc, task) => {
        acc[task.id] = {
            taskIndex: task.taskIndex,
            taskName: task.taskName,
        };
        return acc;
    }, {});

    const usersWithTasks = doaStudyDelegations.map((delegation) => {
        const tasks = delegation.taskIds.map((currentTaskId) => {
            const foundTask = tasksMap[currentTaskId];
            return {
                taskId: currentTaskId,
                taskIndex: foundTask ? foundTask.taskIndex : null,
                taskName: foundTask ? foundTask.taskName : null,
            };
        });

        return {
            id: delegation.id,
            user: delegation.user,
            role: delegation.rolesManagement,
            tasks: tasks,
            startDate: delegation.startDate,
            endDate: delegation.endDate,
            signatures: delegation.signatures,
        };
    });

    return usersWithTasks;
};

const getValidSignaturesByRole = (arrSig, role) => {
    return arrSig.filter(
        (expectation) =>
            (expectation.signatureStatus === 'PENDING' ||
                expectation.signatureStatus === 'COMPLETED' || expectation.signatureStatus === 'INITIATED') &&
            expectation.signatureType.includes(role)
    );
};

const formatDateString = (dateString) => {
    if (dateString) {
        const date = moment.utc(dateString);
        const formattedDate = date.format('DD MMM YYYY');
        return formattedDate;
    } else {
        return null;
    }
};


const gatherDelegationData = async (delegations, signatureExpectationsAll) => {
    const sortedByName = sortBy(delegations, (doa) =>
        toLower(get(doa, ['user', 'displayName'], ''))
    );
    return map(sortedByName, (doa) => {
        const signatureExpectations = signatureExpectationsAll.filter(expectation => expectation.delegationId === doa.id);

        return {
            delegationName: get(doa, ['user', 'displayName']),
            delegationRole: get(doa, ['role', 'name']) || '--',
            delegationRoleId: get(doa, ['role', 'id']),
            delegatedTasks: get(doa, ['tasks']),
            delegationSignatures: signatureExpectations,
            startDate: formatDateString(doa.startDate) || '--',
            endDate: formatDateString(doa.endDate) || '--',
            rawStartDate: doa.startDate,
            rawEndDate: doa.endDate,
            pendingPISignatures: getValidSignaturesByRole(signatureExpectations, 'PI_START'),
            pendingStaffSignatures: getValidSignaturesByRole(signatureExpectations, 'STAFF_START'),
            id: get(doa, ['id']),
            userId: get(doa, ['user', 'id']),
            pendingSignatures: doa.signatures
                ? doa.signatures.filter((item) => item.signatureStatus === 'PENDING')
                : [],
            completeSignatures: doa.signatures
                ? doa.signatures.filter((item) => item.signatureStatus === 'COMPLETED')
                : [],
            initiatedSignatures: doa.signatures
                ? doa.signatures.filter((item) => item.signatureStatus === 'INITIATED') : []
        };
    });
};

const DEFAULT_FILTER = { search: '', filter: {}, sort: { key: 'delegationName', value: 'ASC' }, initial: true };


function DelegationTableNewDOA(props) {
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [allDelegations, setAllDelegations] = useState([]);
    const [filterRecord, setFilterRecord] = useState(DEFAULT_FILTER);
    const [paginationdata, setPagination] = useState({ limit: 25, offset: 0, totalCount: 0 });
    const [isLoading, setIsLoading] = useState(props.loadingStudySignatures || props.doaLoading);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(props.loadingStudySignatures || props.doaLoading);
            const delegations = await delegationsListV2(props.doaStudyDelegations, props.doaStudyTasks);
            const { signatureExpectationsAll } = props;
            const allDelegationsData = await gatherDelegationData(delegations, signatureExpectationsAll);

            setAllDelegations(allDelegationsData);
            setPagination({ ...paginationdata, totalCount: delegations.length });

            const endIndex = Math.min(paginationdata.offset + paginationdata.limit, delegations.length);
            setRows(allDelegationsData.slice(paginationdata.offset, endIndex));
            setFilterRecord(DEFAULT_FILTER);
            setColumns(await buildDelegationColumns(delegations));
            setIsLoading(props.loadingStudySignatures || props.doaLoading);
        };
        fetchData();
        return () => {
            setRows([]);
            setColumns([]);
        };
    }, [props.doaStudyDelegations, props.doaStudyTasks, props.doaLoading, props.loadingStudySignatures]);

    const convertDateFormat = (dateString) => {
        if (dateString === '--') {
            return null;
        }
        const dateObject = new Date(dateString);
        return dateObject.toLocaleDateString('en-US');
    };

    const onRowClick = (data) => {
        const updatedData = {
            ...data,
            startDate: convertDateFormat(data.startDate),
            endDate: convertDateFormat(data.endDate),
        };
        props.onRowClick(updatedData);
    };




    const buildDelegationColumns = async (delegations) => {
        const delegationColumns = [
            {
                title: 'Name',
                field: 'delegationName',
                searchPlaceholder: 'Delegates',
                hidden: false,
                headerStyle: {
                    width: '65%',
                    minWidth: '65%',
                },
                cellStyle: {
                    width: '65%',
                    minWidth: '65%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: 'var(--blue-500, #2057AD)',
                },
                toolbarSearch: true,
                toolbarSort: 'ASC',
                toolbarDefaultSort: true,
                singleSort: false,
                render: rowData => (
                    <span
                        style={{ cursor: 'pointer' }}
                        onClick={() => onRowClick(rowData)}
                    >
                        {rowData.delegationName}
                    </span>
                ),
            },
            {
                title: 'Role',
                field: 'delegationRole',
                hidden: false,
                headerStyle: {
                    width: '6%',
                    minWidth: '6%',
                },
                cellStyle: {
                    width: '6%',
                    minWidth: '6%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                toolbarFilter: FilterState.MULTILIST,
            },
            {
                title: 'Responsibilities',
                field: 'Responsibilities',
                hidden: false,
                headerStyle: {
                    width: '6%',
                    minWidth: '6%',
                },
                cellStyle: {
                    width: '6%',
                    minWidth: '6%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                toolbarFilter: FilterState.MULTILIST,
                toolbarFilterData: props.taskOptions.map(item => ({
                    label: `${item.task.taskIndex}. ${item.task.taskName}`,
                    key: `${item.task.taskIndex}. ${item.task.taskName}`
                })),
                render: (data) => {
                    const taskCount = get(data, 'delegatedTasks.length');
                    const tasks = get(data, 'delegatedTasks');

                    return (
                        <div>
                            <Conditional condition={taskCount > 0}>
                                <DelegationPopoverTaskNewDOA tasks={tasks} />
                            </Conditional>
                            <Conditional condition={taskCount <= 0}>
                                --
                            </Conditional>

                        </div>
                    );
                },
            },
            {
                title: 'Start Date',
                field: 'startDate',
                hidden: false,
                headerStyle: {
                    width: '5%',
                    minWidth: '5%',
                },
                cellStyle: {
                    width: '5%',
                    minWidth: '5%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
            },
            {
                title: 'End Date',
                field: 'endDate',
                hidden: false,
                headerStyle: {
                    width: '5%',
                    minWidth: '5%',
                },
                cellStyle: {
                    width: '5%',
                    minWidth: '5%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
            },
            {
                title: 'PI Signature Status',
                field: 'pendingPISignatures',
                hidden: false,
                headerStyle: {
                    width: '6%',
                    minWidth: '6%',
                },
                cellStyle: {
                    width: '6%',
                    minWidth: '6%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                toolbarFilter: FilterState.MULTILIST,
                toolbarFilterData: [
                    { label: 'Completed', key: 'COMPLETED' },
                    { label: 'Outstanding', key: 'PENDING' },
                    { label: 'Not Requested', key: 'NOT_REQUESTED' }
                ],
                render: (data) => {
                    const piSignatureExpectations = get(data, 'pendingPISignatures');

                    return (
                        isEmpty(piSignatureExpectations) ? '--' : <SignatureStatusNew signatureExpectations={piSignatureExpectations} />
                    );
                },
            },
            {
                title: 'Staff Signature Status',
                field: 'pendingStaffSignatures',
                hidden: false,
                headerStyle: {
                    width: '6%',
                    minWidth: '6%',
                },
                cellStyle: {
                    width: '6%',
                    minWidth: '6%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                toolbarFilter: FilterState.MULTILIST,
                toolbarFilterData: [
                    { label: 'Completed', key: 'COMPLETED' },
                    { label: 'Outstanding', key: 'PENDING' },
                    { label: 'Not Requested', key: 'NOT_REQUESTED' }
                ],
                render: (data) => {
                    const staffSignatureExpectations = get(data, 'pendingStaffSignatures');
                    return (
                        isEmpty(staffSignatureExpectations) ? '--' : <SignatureStatusNew signatureExpectations={staffSignatureExpectations} />
                    );
                },
            },
            {
                title: 'actions',
                field: 'actions',
                hidden: true,
                headerStyle: {
                    width: '6%',
                    minWidth: '6%',
                },
                cellStyle: {
                    width: '6%',
                    minWidth: '6%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: 'var(--blue-500, #2057AD)',
                },
                actions: true,
                actionItems: [
                    { label: 'Set up Responsibilities', key: 'set_up_responsibilities', icon: faList, execute: props.setOpenSidePanel },
                    { label: 'Export Delegation', key: 'export_delegation', icon: faCloudDownload, execute: props.exportAuditLogV2 }
                ]
            },
            {
                title: 'createButton',
                field: 'createButton',
                createButton: true,
                hidden: true,
                label: 'Add Delegation',
                execute: props.createDelegation,
                isCreateAllowed: props.canManageDoALog,
            },
        ];

        return delegationColumns;
    };



    const onFilterChange = (filterRecords = filterRecord, pagination = paginationdata) => {
        if (filterRecords && !filterRecords.initial) {
            setFilterRecord(filterRecords);
            let filteredData = allDelegations;
            const { search, filter, sort } = filterRecords;
            const { delegationRole, pendingStaffSignatures, pendingPISignatures, Responsibilities } = filter;
            if (search && search.trim() !== '') {
                const searchTerm = search.toLowerCase().trim();
                filteredData = filteredData.filter((item) => {
                    const tasks = get(item, 'delegatedTasks', []);
                    const displayNameMatch = get(item, ['delegationName'], '').toLowerCase().includes(searchTerm);
                    const taskMatch = tasks.some(task =>
                        `${task.taskIndex}. ${task.taskName}`.toLowerCase().includes(searchTerm)
                    );
                    return displayNameMatch || taskMatch;
                });
            }

            if (delegationRole && delegationRole.length > 0) {
                const rolesWithoutSuffix = delegationRole.map(role => role.replace('delegationRole', ''));
                filteredData = filteredData.filter((item) => {
                    const itemRole = get(item, ['delegationRole'], '');
                    const roleNameWithoutSuffix = itemRole.replace('delegationRole', '');
                    return rolesWithoutSuffix.includes(roleNameWithoutSuffix);
                });

            }

            if (Responsibilities && Responsibilities.length > 0) {
                filteredData = filteredData.filter((item) => {
                    const tasks = get(item, 'delegatedTasks', []);
                    return tasks.some(task => Responsibilities.includes(`${task.taskIndex + '. ' + task.taskName}`));
                });

            }

            if (pendingStaffSignatures && pendingStaffSignatures.length > 0) {
                filteredData = filteredData.filter((item) => {
                    const staffSignatureExpectations = get(item, 'pendingStaffSignatures');
                    const signatureCount = staffSignatureExpectations.filter(
                        (expectation) => expectation.signatureStatus === 'PENDING'
                    ).length;

                    if (!isEmpty(staffSignatureExpectations)) {
                        if (signatureCount === 0) {
                            if (filter.pendingStaffSignatures.includes('COMPLETED')) {
                                return true;
                            }
                        } else {
                            if (filter.pendingStaffSignatures.includes('PENDING')) {
                                return true;
                            }
                        }
                    } else {
                        if (filter.pendingStaffSignatures.includes('NOT_REQUESTED')) {
                            return true;
                        }
                    }
                    return false;
                });
            }

            if (pendingPISignatures && pendingPISignatures.length > 0) {
                filteredData = filteredData.filter((item) => {
                    const piSignatureExpectations = get(item, 'pendingPISignatures');
                    const signatureCount = piSignatureExpectations.filter(
                        (expectation) => expectation.signatureStatus === 'PENDING'
                    ).length;

                    if (!isEmpty(piSignatureExpectations)) {
                        if (signatureCount === 0) {
                            if (filter.pendingPISignatures.includes('COMPLETED')) {
                                return true;
                            }
                        } else {
                            if (filter.pendingPISignatures.includes('PENDING')) {
                                return true;
                            }
                        }
                    } else {
                        if (filter.pendingPISignatures.includes('NOT_REQUESTED')) {
                            return true;
                        }
                    }
                    return false;
                });
            }
            if (sort && sort.key && sort.value) {
                filteredData = orderBy(filteredData, [(doa) =>
                    toLower(get(doa, ['delegationName'], ''))
                ], [sort.value === 'ASC' ? 'asc' : 'desc']
                );
            }
            if (
                delegationRole.length > 0 ||
                (search && search.trim() !== '') ||
                Responsibilities.length > 0 ||
                pendingStaffSignatures.length > 0 ||
                pendingPISignatures.length > 0
            ) {
                const updatedTotalCount = filteredData.length;
                let updatedOffset = pagination.offset;

                if (pagination.limit && pagination.limit > 0 && updatedTotalCount > 10) {
                    updatedOffset = Math.min(updatedOffset, pagination.limit - updatedTotalCount);
                } else {
                    updatedOffset = 0;
                }

                setPagination({ ...paginationdata, totalCount: updatedTotalCount, offset: updatedOffset, limit: pagination.limit });

                const endIndex = Math.min(updatedOffset + pagination.limit, updatedTotalCount);
                setRows(filteredData.slice(updatedOffset, endIndex));
            } else {
                setPagination({ ...paginationdata, totalCount: allDelegations.length, offset: pagination.offset, limit: pagination.limit });

                const endIndex = Math.min(pagination.offset + pagination.limit, allDelegations.length);
                setRows(filteredData.slice(pagination.offset, endIndex));
            }

        }
    };
    const showZeroStateForFilter = (
        (Object.values(filterRecord.filter).length > 0 || Object.values(filterRecord.search).length > 0) &&
        rows.length === 0
    );

    if (props.doaLoading || isLoading) {
        return <Spinner actionLabel={'Loading'} itemName={'Delegation Of Authority'} />;
    }
    return (
        <div className={props.isBinderTab && styles.ContainerPadding}>
            <StudyUsersTeamTable
                onFilterUpdate={onFilterChange}
                filterRecord={filterRecord}
                setFilterRecord={setFilterRecord}
                rows={rows}
                columns={columns}
                pagination={paginationdata}
                setPagination={setPagination}
                onChangePagination={(pagination) => onFilterChange(filterRecord, pagination)}
                dataCy="delegations"
                footerLabel='delegates'
                handleRowClick={onRowClick}
                isEditAllowed={props.canManageDoALog}
                isRemoveAllowed={props.canManageDoALog}
                showZeroStateForFilter={showZeroStateForFilter}
            />
        </div>
    );
}

export default connect(
    (state, _props) => {
        const taskOptions = getDelegationTaskOptions(state);
        const doaStudyDelegations = get(state, 'doaStudyDelegations', null);
        const doaStudyTasks = get(state, 'doaStudyTasks', null);
        const doaLoading = get(state, 'app.loadingStudyDelegations', false);
        const studyPermissions = get(state, 'me.studyPermissions', {});
        const loadingStudySignatures = get(state, 'app.loadingStudySignatures', false);
        return {
            taskOptions,
            doaStudyDelegations,
            loadingStudySignatures,
            doaStudyTasks,
            doaLoading,
            studyPermissions,
        };
    }, null
)(DelegationTableNewDOA);